<template>
    <div class="box autho-manage">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <div style="display: flex;align-items: center">
                <span class="el-icon-back" style="font-size: 30px;margin-right: 15px;cursor:pointer"
                    @click="handleBack"></span>
                <el-breadcrumb-item>标签详情</el-breadcrumb-item>
            </div>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <h1 style="text-align: left;color: #666">当前批次：{{LabelBatch}}</h1>
        <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input placeholder="根据标签号查询" v-model="model.SearchKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-upload class="upload-demo" action="" :on-change="handleDownloadUrlChange"
                    :http-request="handleHttpRequestDownload" :on-exceed="handleDownloadOver" :limit="limitDownload"
                    :file-list="fileDownloadUrlList" accept=".txt">
                    <el-button size="small" type="primary" style="padding:12px 20px;font-size:14px;margin-right:10px">导入
                    </el-button>
                    <span slot="tip" class="el-upload__tip">只能上传.txt文件类型</span>
                </el-upload>
            </el-form-item>
            <!-- <el-form-item>
                <el-button type="danger" @click="handleDeleteAll">批量删除</el-button>
            </el-form-item> -->
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%" @selection-change="selectChange"
            highlight-current-row :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="124">
            </el-table-column>
            <el-table-column prop="LableDetailOID" label="ID" sortable width="180">
            </el-table-column>
            <el-table-column prop="LabelBatch" label="标签批次" sortable width="180">
            </el-table-column>
            <el-table-column prop="LabelNo" label="标签RFID" sortable width="180">
            </el-table-column>
            <el-table-column prop="IsInvalid" label="是否已使用" sortable width="180">
                <template slot-scope="scope">
                    <el-switch v-model="scope.IsInvalid">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="标签创建时间" sortable width="180">
            </el-table-column>
            <el-table-column prop="UpdateTime" label="标签修改时间" sortable width="180">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.OID!=1">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px;">
            <el-pagination background @current-change="handleCurrentChange" :current-page="model.Page"
                layout="total,prev, pager, next, jumper" :total="listCount" :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :LabelNo="LabelNo"
            :LableDetailOID="LableDetailOID"></edit>
    </div>
</template>

<script>
    import {
        GetLableDetailInfo,
        UploadLableDetail,
        DelLableDetail
    } from '../../../api/tag'
    import {
        UpdateDeviceAppCategory
    } from '../../../api/appType'
    import edit from './edit'
    export default {
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                isShowClone: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    LabelBatch: null,
                    IsInvalid: 0 //是否已失效 0-全部；1-有效；2-已失效；
                },
                limitDownload: 1,
                fileDownloadUrlList: [],
                LabelNo: null,
                LableDetailOID: null,
                checkAll: false,
                selectList: []
            }
        },
        props: {
            LabelBatch: {
                required: true,
            },
        },
        components: {
            edit
        },
        watch: {
            'model.SearchKey': {
                handler(newVal, oldVal) {
                    if (newVal === '') {
                        this.model.SearchKey = '';
                        this.GetLableDetailInfo();
                    } else {
                        this.model.SearchKey = this.model.SearchKey.trim();
                    }
                }
            }
        },
        mounted() {
            this.model.LabelBatch = this.LabelBatch;
            this.GetLableDetailInfo();
        },
        methods: {
            GetLableDetailInfo() {
                GetLableDetailInfo(this.model).then(data => {
                    if (!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                        this.fileDownloadUrlList = [];
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetLableDetailInfo();
            },
            selectChange(val) {
                // this.selectdata = val
                console.log(val)
                this.selectList = val;
            },
            handleSearch() {
                if (this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetLableDetailInfo();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                console.log(row)
                this.LabelNo = row.LabelNo;
                this.LableDetailOID = row.LableDetailOID;
                this.isShowEdit = true;
            },
            handleCloseAdd() {
                this.isShowAdd = false;
                this.GetLableDetailInfo();
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetLableDetailInfo();
            },
            handleDelete(row) {
                let id = row.LableDetailOID;
                this.$confirm('确认要删除该应用吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DelLableDetail(id);
                })
            },
            DelLableDetail(id) {
                DelLableDetail({
                    LableDetailOID: id
                }).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetLableDetailInfo();
                    }
                })
            },
            handleHttpRequestDownload(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                formdata.append('LabelBatch', this.model.LabelBatch)
                UploadLableDetail(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.GetLableDetailInfo();
                    }
                })
            },
            handleDownloadOver() {
                this.$message({
                    message: '只能上传一个文件',
                    type: 'error'
                });
            },
            handleDownloadUrlChange(file, fileList) {
                this.fileDownloadUrlList = fileList.slice(-1);
            },
            handleDeleteAll() {
                if (!this.selectList.length) {
                    this.$message({
                        message: '请先选择要删除的数据',
                        type: 'warning'
                    });
                    return false;
                }
            },
            handleBack() {
                this.$emit('closeDetail')
            },

        }
    }
</script>

<style>
    .box.autho-manage .el-table th,
    .box.autho-manage .el-table tr {
        background-color: #ecf5ff;
    }
</style>